export default "__VITE_ASSET__DXkn_W2K__"